import React, { useEffect } from 'react';
// import fullRoute from '@/routes/route-config'
import Container from '@/components/container';
import { connect } from 'react-redux';
// to-change
import url from 'url';
import { Link, withRouter } from 'react-router-dom';
import goto from '@/common/utils/goto';
import cachedCrumbs from './cached-crumbs';
import { isChildPath } from '@/common/utils/path';
import './index.less';
import { ArrowLeftOutlined, RightOutlined } from '@ant-design/icons';

const Url = new url.Url();

// 是否严格
function isStrict(routeItem) {
  if (routeItem.path[routeItem.path.length - 1] === '*') return false;
  if (routeItem.strict || !routeItem.menus) return true;
  return false;
}

/**
 * 将首页{title: 首页, path: '/'} 添加到面包屑数组开始位置
 *
 * @param {[{title: '', path: ''}]} crumbs
 */
function unshfitIndexRoute(crumbs) {
  if (crumbs.length === 0) return crumbs;

  if (crumbs[0].path === '/') return crumbs;

  crumbs.unshift({ title: '首页', path: '/' });

  return crumbs;
}

/**
 * 是否相等
 *
 * @param {string} parentPath
 * @param {string} childPath
 * @returns boolean
 * @example
 *
 * /a /a true
 * /a/* /a/b true
 */
function parentPathEqChildPath(parentPath, childPath) {
  if (parentPath === childPath) return true;

  // 如果路由中有params的话，需要单独匹配
  const parentPathArr = parentPath.split('/');
  const childPathArr = childPath.split('/');

  if (parentPathArr.length === childPathArr.length) {
    let isMatch = true;
    parentPathArr.map((item, index) => {
      if (!/^:/.test(item) && item !== childPathArr[index]) {
        isMatch = false;
      }
    });
    if (isMatch) return true;
  }

  // if (/\*|:/.test(parentPathArr[parentPathArr.length - 1])) return isChildPath(parentPath, childPath)
  if (parentPath[parentPath.length - 1] === '*') return isChildPath(parentPath, childPath);
}

/**
 * 根据pathname搜索路由树获取到当前pathname对应的面包屑
 *
 * @param {*} pathTree
 * @param {*} targetPath 当前路径pathname
 * @param {*} context
 */
function getPathStack(pathTree, targetPath, context) {
  let crumbs = [];

  // 部分页面的面包屑是动态生成的，没有完成生成前不展示
  let canShow = true;

  deepSearch(pathTree, targetPath, undefined, context);

  if (!canShow) return [];

  crumbs = crumbs.filter((item) => !!item.title);

  crumbs = unshfitIndexRoute(crumbs);

  // 处理下最后一个，最后一个不可点击或者刷新当前页面
  if (crumbs.length) {
    const lastIndex = crumbs.length - 1;
    crumbs[lastIndex].path += !crumbs[lastIndex].path.includes('?') ? window.location.search : '';
    crumbs[lastIndex].path += !crumbs[lastIndex].path.includes('#') ? window.location.hash : '';
  }

  return crumbs;

  function deepSearch(pathTree, targetPath, routePath = '', context) {
    if (!pathTree) {
      console.error('遍历完成整个树没找到' + targetPath + '的面包屑路由');
      return;
    }

    var pathItem = null;
    var curRoutePath = null;
    // 只搜索第一个匹配的
    for (var i = 0, len = pathTree.length; i < len; i++) {
      pathItem = pathTree[i];
      curRoutePath = routePath + pathItem.path;

      // 完全相等无论是否是严格都匹配成功
      if (parentPathEqChildPath(curRoutePath, targetPath)) {
        if (typeof pathItem.getCrumb === 'function' && pathItem.getCrumb.length !== 0 && !context.breadCrumbs.canShow) {
          canShow = false;
          return;
        }
        generaterCrumb(routePath, pathItem, context).forEach((item) => crumbs.push(item));
        // adapterIfResIsArr(crumbs, generaterCrumb(routePath, pathItem, context))
        break;
      } else {
        if (isChildPath(curRoutePath, targetPath)) {
          // 如果不需要严格匹配则可以，否则要走上面的equal
          if (!isStrict(pathItem)) {
            if (
              typeof pathItem.getCrumb === 'function' &&
              pathItem.getCrumb.length !== 0 &&
              !context.breadCrumbs.canShow
            ) {
              canShow = false;
              return;
            }
            generaterCrumb(routePath, pathItem, context).forEach((item) => crumbs.push(item));
            // adapterIfResIsArr(crumbs, generaterCrumb(routePath, pathItem, context))
            deepSearch(pathItem.menus, targetPath, curRoutePath, context);
            break;
          }
        }
      }
    }
  }

  // 根据路由上的getCrumb方法动态获取面包屑导航
  // context有两个信息，一个是整个路由信息menus: 一个是业务数据breadCrumbs
  function generaterCrumb(curPath, pathItem, context) {
    const getCrumb = pathItem.getCrumb;
    let crumb = [{ path: pathItem.path, title: pathItem.title }];

    // 同步修改context，使用的时候异步获取会非预期
    context.crumb = pathItem;

    if (typeof getCrumb === 'function') crumb = getCrumb.call(context, context, curPath);

    if (crumb == null || !crumb) return [];

    if (!Array.isArray(crumb)) crumb = [crumb];

    crumb.forEach((curmbItem) => {
      if (curmbItem.path == null) curmbItem.path = joinPath(curPath, pathItem.path, curmbItem.curmbIsAbsolute);
      else {
        curmbItem.path = joinPath(curPath, curmbItem.path, curmbItem.curmbIsAbsolute);
      }
      if (curmbItem.title == null) curmbItem.title = pathItem.title;
    });
    return crumb;

    function joinPath(parentPath, childPath, isAbsolute = false) {
      if (isAbsolute && childPath && childPath[0] === '/') return childPath;

      if (childPath[0] === '/') return parentPath + childPath;

      return parentPath + '/' + childPath;
    }
  }
}

const TplBreadCrumbs = connect(({ breadCrumbsInfo }) => ({
  breadCrumbsInfo,
}))(InnerTplBreadCrumbs);

const BreadCrumbs = connect(({ menus, breadCrumbs }) => {
  return { menus, breadCrumbs };
})(
  /* 需要要监听路由变动 */ withRouter((props) => {
    const renderCrumbs = props.renderCrumbs;
    const pathStach = getPathStack(props.menus, Url.parse(window.location.href).pathname, {
      menus: props.menus,
      breadCrumbs: props.breadCrumbs,
    });

    cachedCrumbs.setCrumbs(pathStach);

    useEffect(() => cachedCrumbs.resetCrumbs);

    return renderCrumbs ? renderCrumbs(pathStach) : <TplBreadCrumbs breadCrumbs={pathStach} />;
    // return showNavBar ? <NavigationBar breadCrumbs={pathStach} /> : <TplBreadCrumbs breadCrumbs={pathStach} />;
  })
);

/**
 * 分隔符可定义 层级可定义
 *
 * @param {*} param0
 */
function InnerTplBreadCrumbs({ breadCrumbs, breadCrumbsInfo }) {
  if (!breadCrumbsInfo.show) return null;

  const _length = breadCrumbs.length;

  let overload = false;

  /**
   * 多余四级 等级1 / 等级2 / 等级3 / 等级4
   * 返回上一页 ... / 等级2 / 等级3 / 等级4
   */
  // 此功能因为无从判断是否有上一级而去除，5调整为999即可屏蔽功能
  if (_length >= 999) {
    overload = true;

    breadCrumbs = breadCrumbs.slice(-4);
    breadCrumbs.unshift({ omit: true, path: 'omit' });
  }

  return (
    <Container margin={false} padding={{ left: true }} paddingSize="min" className="bread-crumbs">
      {overload ? (
        <a className="bread-crumbs-prev" onClick={() => goto.prev()}>
          {'<'} 返回上一页
        </a>
      ) : null}
      {breadCrumbs.map((item, index) => {
        // 最有一个面包屑不能点击，并且没有右边的分割符 /
        if (index === breadCrumbs.length - 1) {
          return (
            <span data-link={item.path} key={item.path} className="bread-crumbs-lastest-item">
              {item.title}
            </span>
          );
        }

        return (
          <React.Fragment key={item.path}>
            {item.omit ? (
              <span className="bread-crumbs-item">...</span>
            ) : (
              <Link className="bread-crumbs-item" to={item.path}>
                {item.title}
              </Link>
            )}
            {' / '}
          </React.Fragment>
        );
      })}
    </Container>
  );
}

export default BreadCrumbs;

export { updateCrumbs, resetCrumbs } from './update-crumb';
